<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_vii"></a><span class="bold">Praise for<br/><em class="italic">Free People, Free Markets</em></span></h2>
<div class="extract">
<p class="noindent">Ralph Bayrer’s new book, <em class="italic">Free People-Free Markets: Their Evolutionary Origins</em>, is a timely reaffirmation of freedom’s central role in the creation of American prosperity and the most celebrated advances of western civilization. Relying on thorough scholarship and clarity of argument, Bayrer makes the compelling case that mankind’s progress in the last millennium rests on a narrow foundation of freedom, a lesson people forget at their peril.</p>
<p class="noindent1">—John McCain</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_praise.vue?a530da5c